import { getHeaders } from '../xhrRequest';
import { createAction } from 'redux-api-middleware';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const SOCIAL_LOGIN = 'SOCIAL_LOGIN';
export const SOCIAL_LOGIN_SUCCESS = 'SOCIAL_LOGIN_SUCCESS';
export const SOCIAL_LOGIN_FAILURE = 'SOCIAL_LOGIN_FAILURE';

export const SIGN_UP = 'SIGN_UP';
export const SIGN_UP_SUCCESS = 'SIGN_UP_SUCCESS';
export const SIGN_UP_FAILURE = 'SIGN_UP_FAILURE';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const GET_USER = 'SET_USER';
export const GET_USER_SUCCESS = 'SET_USER_SUCCESS';
export const GET_USER_FAILURE = 'SET_USER_FAILURE';

// export const USER_COUNTRY_CODE = 'USER_COUNTRY_CODE';
// export const USER_COUNTRY_CODE_SUCCESS = 'USER_COUNTRY_CODE_SUCCESS';
// export const USER_COUNTRY_CODE_FAILURE = 'USER_COUNTRY_CODE_FAILURE';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const login = data => createAction({
    types: [
        LOGIN,
        {
            type: LOGIN_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        LOGIN_FAILURE
    ],
    endpoint: `/api/user/sign-in`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const socialLogin = data => createAction({
    types: [
        {
            type: SOCIAL_LOGIN,
            payload: {
                showPreloader: true,
            }
        },
        {
            type: SOCIAL_LOGIN_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        SOCIAL_LOGIN_FAILURE
    ],
    endpoint: `/api/user/social-auth`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const signUp = data => createAction({
    types: [
        SIGN_UP,
        {
            type: SIGN_UP_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        SIGN_UP_FAILURE
    ],
    endpoint: `/api/user/sign-up`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});

export const logout = () => createAction({
    types: [
        LOGOUT,
        LOGOUT_SUCCESS,
        LOGOUT_FAILURE
    ],
    endpoint: `/api/user/logout`,
    headers: getHeaders(),
    method: 'POST',
    credentials: 'include'
});

export const getUser = () => createAction({
    types: [
        GET_USER,
        {
            type: GET_USER_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json.hasOwnProperty('status') ? {} : json;
                });
            }
        },
        GET_USER_FAILURE
    ],
    endpoint: `/api/user/user`,
    headers: getHeaders(),
    method: 'GET',
    credentials: 'include'
});

// export const getUserCountryCode = () => createAction({
//     types: [
//         USER_COUNTRY_CODE,
//         {
//             type: USER_COUNTRY_CODE_SUCCESS,
//             payload: (action, state, res) => {
//                 return res.json().then(json => {
//                     return {
//                         countryCode: json.code
//                     };
//                 });
//             }
//         },
//         USER_COUNTRY_CODE_FAILURE
//     ],
//     endpoint: `/api/country/iso-code`,
//     headers: getHeaders(),
//     method: 'GET',
//     credentials: 'include'
// });

export const updateUser = data => createAction({
    types: [
        UPDATE_USER,
        {
            type: UPDATE_USER_SUCCESS,
            payload: (action, state, res) => {
                return res.json().then(json => {
                    return json;
                });
            }
        },
        UPDATE_USER_FAILURE
    ],
    endpoint: `/api/user-info/full-update`,
    headers: getHeaders(),
    method: 'POST',
    body: JSON.stringify(data),
    credentials: 'include'
});
